<template>
  <div>
    <div class="app-card-header primary-actions">
      <div class="heading-block">
        <h4 class="heading">Competitors Coverage</h4>
      </div>
    </div>
    <div class="card-body pa-0">
      <Chart
        :brand="brand.model"
        :seller="seller.model"
        :category="category.model"
        :height="chartHeight"
        :chartStatus="getChartStatus"
        :chartOptions="chartOptions"
        :columnWidth="columnWidth" />
    </div>
  </div>
</template>

<script>
import Chart from './chart'
export default {
  name: 'block',
  props: {
    chartHeight: {
      type: [String, Number],
      default: null
    },
    columnWidth: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    Chart
  },
  data: () => ({
    category: {
      isLoading: false,
      items: [],
      model: [],
      search: null
    },
    seller: {
      isLoading: false,
      items: [],
      model: [],
      search: null
    },
    brand: {
      isLoading: false,
      items: [],
      model: [],
      search: null
    },
    popup: {
      dialog: false
    },
    allowRequest: true,
    timer: 1
  }),
  computed: {
    getChartStatus () {
      return this.$store.state.analyticsCompetitorsCoverageModule.chartStatus
    },
    getCategories () {
      return this.$store.state.analyticsCompetitorsCoverageModule.categories
    },
    brands () {
      return this.$store.state.analyticsCompetitorsCoverageModule.brands
    },
    chartOptions () {
      return this.$store.state.analyticsCompetitorsCoverageModule.chartOptions
    },
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor
    }
  },
  methods: {
    updateByFilters () {
      if (!this.allowRequest) return
      this.$store.dispatch('analyticsCompetitorsCoverageModule/getChart', {
        brandId: this.brand.model,
        categoryId: this.category.model,
        elemRef: this.$refs.chartCompetitorsCoverage,
        elemRefPopup: this.$refs.chartCompetitorsCoveragePopup
      })
    },
    resetFilter () {
      this.allowRequest = false
      this.category.search = null
      this.category.model = 0
      this.brand.search = null
      this.brand.model = 0
      this.$store.dispatch('analyticsCompetitorsCoverageModule/getChart', {
        brandId: 0,
        categoryId: 0,
        elemRef: this.$refs.chartCompetitorsCoverage,
        elemRefPopup: this.$refs.chartCompetitorsCoveragePopup
      }).then(() => {
        this.allowRequest = true
      }).catch(() => {
        this.allowRequest = true
      })
    },
    openModal () {
      this.popup.dialog = true
    }
  },
  watch: {
    // Competitors Coverage
    'category.search': function (val) {
      if (val === '' || val === null) {
        this.category.model = 0
        this.category.items = []
        return
      }
      let vm = this
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.category.isLoading = true
        this.$store.dispatch('analyticsCompetitorsCoverageModule/getCategories', {
          categoryName: val,
          brandId: vm.brand.model
        }).then(() => {
          this.category.isLoading = false
        })
      }, 300)
    },
    'brand.search': function (val) {
      if (val === '' || val === null) {
        this.brand.model = 0
        this.brand.items = []
        return
      }
      let vm = this
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.brand.isLoading = true
        this.$store.dispatch('analyticsCompetitorsCoverageModule/getBrands', {
          brandName: val,
          categoryId: vm.category.model
        }).then(() => {
          this.brand.isLoading = false
        })
      }, 300)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/analytics/competitors-coverage/parentComponent.vue